import React from "react";
import {Button} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faUserPlus,
  faLaptop,
  faCartPlus,
  faMoneyBill,
} from "@fortawesome/free-solid-svg-icons";
import {Link} from "react-router-dom";

const Home = () => {
  return (
    <section className="position-relative overflow-hidden pt-5 pt-lg-3">
      <div style={{textAlign: "center"}}>
        <h1 className="text-center">개인 학습자</h1>

        <div className="tab-content" id="course-pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="course-pills-tabs-1"
            role="tabpanel"
            aria-labelledby="course-pills-tab-1"
          >
            <div className="row g-4">
              <div className="col-sm-6 col-lg-4 col-xl-3">
                <div className="card shadow h-100">
                  <Link to="/personalRegistration" className="mb-3">
                    <Button
                      variant="primary"
                      size="lg"
                      className="card-img-top"
                    >
                      <FontAwesomeIcon icon={faUserPlus} className="me-2" />
                      회원 가입
                    </Button>

                    <div className="card-body pb-0">
                      <p className="mb-2 text-truncate-2">
                        구매와 학습에 사용하는 계정 생성
                      </p>
                      <ol className="text-primary" style={{textAlign: "left"}}>
                        전체 프로세스
                        <li>회원 가입 / 로그인</li>
                        <li>제품 선택</li>
                        <li>결제</li>
                        <li>학습 시작</li>
                      </ol>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-sm-6 col-lg-4 col-xl-3">
                <div className="card shadow h-100">
                  <Link to="/personalLogin" className="mb-3">
                    <Button
                      variant="primary"
                      size="lg"
                      className="card-img-top"
                    >
                      <FontAwesomeIcon icon={faLaptop} className="me-2" />
                      로그인
                    </Button>

                    <div className="card-body pb-0">
                      <p className="mb-2 text-truncate-2">
                        라이선스 구매를 위한 로그인
                      </p>
                      <ol className="text-primary" style={{textAlign: "left"}}>
                        <li>처음 시작할 때</li>
                        <li>라이선스 만료 후</li>
                        <li>라이선스 기간 연장</li>
                      </ol>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-sm-6 col-lg-4 col-xl-3">
                <div className="card shadow h-100">
                  <Link to="/payment" className="mb-3">                  
                    <Button
                      variant="primary"
                      size="lg"
                      className="card-img-top"
                    >
                      <FontAwesomeIcon icon={faCartPlus} className="me-2" />
                      라이선스 구매
                    </Button>

                    <div className="card-body pb-0">
                      <p className="mb-2 text-truncate-2">
                        제품과 기간별 라이선스 구매
                      </p>
                      <ol className="text-primary" style={{textAlign: "left"}}>
                        <li>제품별 사용기간 선택</li>
                        <li>결제</li>
                      </ol>
                      <div>
                        <img
                          src="assets/images/pay/payment_icon_yellow_small.png"
                          alt="카카오페이"
                          className="w-5 h-5"
                        />                   
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
              <div className="col-sm-6 col-lg-4 col-xl-3">
                <div className="card shadow h-100">
                  <Link to="/mydesk" className="mb-3">
                    <Button
                      variant="primary"
                      size="lg"
                      className="card-img-top"
                    >
                      <FontAwesomeIcon icon={faMoneyBill} className="me-2" />
                      구매 내역
                    </Button>

                    <div className="card-body pb-0">
                      <p className="mb-2 text-truncate-2">
                        주문, 결제 내역 확인
                      </p>
                      <ul className="text-primary" style={{textAlign: "left"}}>
                        <li>주문 내역</li>
                        <li>결제 내역</li>
                      </ul>
                    </div>
                  </Link>
                  <Link to="/orderCancel" className="mb-3">
                    <div className="card-body pb-0">
                      <p className="mb-2 text-truncate-2">
                        주문, 결제 취소 처리
                      </p>
                      <ul className="text-primary" style={{textAlign: "left"}}>
                        <li>취소 요청</li>
                      </ul>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Home;
